import { Component, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { IdleService } from '../../utility/idle.service';

@Component({
  selector: 'lib-generic-logout-warning-dialog',
  templateUrl: './generic-logout-warning-dialog.component.html',
  styleUrls: ['./generic-logout-warning-dialog.component.scss'],
})
export class GenericLogoutWarningDialogComponent implements OnDestroy {
  countdown: string;
  countdownInterval: NodeJS.Timeout;

  constructor(
    public dialogRef: MatDialogRef<GenericLogoutWarningDialogComponent>,
    private idleService: IdleService,
  ) {
    this.countdown = this.downTimer(this.idleService.secondsUntilTimeOut());
    this.countdownInterval = setInterval(() => {
      if (this.idleService.userHasTimedOut()) {
        this.idleService.onIdleTimeout(true);
        this.dialogRef.close(false);
      } else {
        const secsUntilTimeOut = this.idleService.secondsUntilTimeOut();
        if (secsUntilTimeOut == null) {
          // idle popup was closed with "log out now". No idle information exists. Timeout now
          this.idleService.onIdleTimeout(false);
          this.dialogRef.close(false);
        } else if (secsUntilTimeOut > this.idleService.IDLE_COUNTDOWN_MINS * 60) {
          // idle popup was closed and login refreshed - close this current dialog
          this.dialogRef.close(false);
        } else {
          this.countdown = this.downTimer(secsUntilTimeOut);
        }
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    clearInterval(this.countdownInterval);
  }

  downTimer(seconds) {
    const mins = Math.floor(((seconds % 86400) % 3600) / 60);
    const secs = ((seconds % 86400) % 3600) % 60;
    return ('00' + mins).slice(-2) + ':' + ('00' + secs).slice(-2);
  }
}
